import { observer } from 'mobx-react-lite';
import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

import { useFileUpload } from '../../hooks/useFileUpload';
import { useVideoCreatorStore } from '../../stores-v2';

import type { FileUploadType } from '../../hooks/useFileUpload';
import type { Artifact } from '../../types.ts/story';

type Props = {
  setIsLoading: (loading: boolean) => void;
  Button?: React.ReactNode;
  width?: string;
  onClick: () => void;
  type?: FileUploadType;
  callback?: (artifacts: Artifact[]) => void;
};

const FileUpload = observer((props: Props) => {
  const { setIsLoading, type, callback, onClick } = props;
  const fileInputRef = useRef<HTMLInputElement>(null);
  const videoCreator = useVideoCreatorStore();

  const { handleUploadFiles, acceptFormats } = useFileUpload({
    uploadType: type,
    onUploadStart: () => setIsLoading(true),
    onUploadComplete: artifacts => {
      if (callback && artifacts) {
        callback(artifacts);
      }
      setIsLoading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    },
    onUploadError: error => {
      console.log('FileUpload error: ', error);
      setIsLoading(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      videoCreator.toastState = {
        state: 'error',
        message: 'Upload failed, please try again or contact Arbor support',
      };
    },
  });

  const handleClick = () => {
    onClick();
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <Main width={props.width} onClick={handleClick}>
      {props.Button}

      <File
        ref={fileInputRef}
        type="file"
        title=""
        multiple
        accept={acceptFormats.join(',')}
        onChange={handleUploadFiles}
      />
    </Main>
  );
});

export default FileUpload;

const Main = styled.div<{ width?: string }>`
  position: relative;
  cursor: pointer;

  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `}
`;

const File = styled.input`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
`;
